//action type 单独处于一个文件夹 便于管理
export const Change_clientHW = 'changeclientHW'

export const Change_userData = 'changeuserdata'

export const Change_configImage = 'changeconfigimage'

export const Change_ModuleData = 'changemoduledata'

export const Change_deptData = 'changedeptdata'